import FormGroupSecondView from './src/formGroupSecondView.vue';

/* istanbul ignore next */
FormGroupSecondView.install = function(Vue) {
    Vue.component(FormGroupSecondView.name, FormGroupSecondView);
};

export default FormGroupSecondView;